import React, { useState, useRef, useEffect } from "react"
import { Document, Page, pdfjs } from "react-pdf"
import FormIo from './Pengadaan/FormIo'

pdfjs.GlobalWorkerOptions.workerSrc = `${process.env.PUBLIC_URL}/pdf.worker.min.js`
const {REACT_APP_BACKEND_URL} = process.env
const filePict = ['png', 'jpg', 'jpeg', 'bmp']

export default function AllPages(props) {
  const [numPages, setNumPages] = useState(null)
  const [scale, setScale] = useState(1)
  const [position, setPosition] = useState({ x: 0, y: 0 })
  const [isDragging, setIsDragging] = useState(false)
  const [dragStart, setDragStart] = useState({ x: 0, y: 0 })
  const [isLoaded, setIsLoaded] = useState(false)
  const [imgSrc, setImgSrc] = useState(null)
  const [pdfSrc, setPdfSrc] = useState(null)
  const containerRef = useRef(null)
  const contentRef = useRef(null)

  function onDocumentLoadSuccess({ numPages }) {
    setNumPages(numPages)
    setIsLoaded(true)
  }

  useEffect(() => {
    if (isLoaded && containerRef.current && contentRef.current) {
      setPosition({ x: 0, y: 0 })
    }
  }, [isLoaded, numPages])

  const { pdf, dataFile, noDoc, noTrans, detailForm, tipe } = props
  const genData = dataFile === undefined ? ['file.pdf'] : dataFile.path.split('/')
  const cekDoc = genData[genData.length - 1].split('.')
  const cekPr = genData.find(item => (item === 'printPR' || item === 'printFRI' || item === 'bidding'))
  const pathData = genData[genData.length - 1]

  const isImage = cekDoc.length !== 0 && filePict.find(item => item === cekDoc[cekDoc.length - 1].toString().toLowerCase()) !== undefined
  const isPdf = cekDoc.length !== 0 && (cekDoc[cekDoc.length - 1].toString().toLowerCase() === 'pdf' || cekPr !== undefined)

  // fetch image dengan token
  useEffect(() => {
    if (!isImage || !pathData) return

    let objectUrl = null

    const fetchImage = async () => {
      try {
        const token = localStorage.getItem('token')
        const res = await fetch(`${REACT_APP_BACKEND_URL}/uploads/${pathData}`, {
          headers: { Authorization: `Bearer ${token}` }
        })
        const blob = await res.blob()
        objectUrl = URL.createObjectURL(blob)
        setImgSrc(objectUrl)
      } catch (err) {
        console.error('Failed to load image', err)
      }
    }

    fetchImage()

    return () => {
      if (objectUrl) URL.revokeObjectURL(objectUrl)
    }
  }, [pathData, isImage])

  // fetch pdf dengan token
  useEffect(() => {
    if (!isPdf || !pdf) return

    let objectUrl = null

    const fetchPdf = async () => {
      try {
        const token = localStorage.getItem('token')
        const res = await fetch(pdf, {
          headers: { Authorization: `Bearer ${token}` }
        })
        const blob = await res.blob()
        objectUrl = URL.createObjectURL(blob)
        setPdfSrc(objectUrl)
      } catch (err) {
        console.error('Failed to load pdf', err)
      }
    }

    fetchPdf()

    return () => {
      if (objectUrl) URL.revokeObjectURL(objectUrl)
    }
  }, [pdf, isPdf])

  useEffect(() => {
    const container = containerRef.current
    if (!container) return

    const handleWheel = (e) => {
      if (e.ctrlKey) {
        e.preventDefault()
        e.stopPropagation()
        const delta = e.deltaY > 0 ? -0.1 : 0.1
        const newScale = Math.min(Math.max(0.5, scale + delta), 3)
        setScale(newScale)
      } else {
        e.stopPropagation()
      }
    }

    container.addEventListener('wheel', handleWheel, { passive: false })
    return () => container.removeEventListener('wheel', handleWheel)
  }, [scale])

  const handleMouseDown = (e) => {
    e.preventDefault()
    setIsDragging(true)
    setDragStart({ x: e.clientX - position.x, y: e.clientY - position.y })
  }

  const handleMouseMove = (e) => {
    if (isDragging) {
      e.preventDefault()
      setPosition({ x: e.clientX - dragStart.x, y: e.clientY - dragStart.y })
    }
  }

  const handleMouseUp = () => setIsDragging(false)
  const handleMouseLeave = () => setIsDragging(false)
  const handleDoubleClick = () => {
    setScale(1)
    setPosition({ x: 0, y: 0 })
  }

  const containerEvents = {
    onMouseDown: handleMouseDown,
    onMouseMove: handleMouseMove,
    onMouseUp: handleMouseUp,
    onMouseLeave: handleMouseLeave,
    onDoubleClick: handleDoubleClick
  }

  const zoomInfo = (
    <div style={{
      position: 'absolute',
      bottom: '10px',
      right: '10px',
      background: 'rgba(0,0,0,0.7)',
      color: 'white',
      padding: '5px 10px',
      borderRadius: '4px',
      fontSize: '11px',
      userSelect: 'none',
      pointerEvents: 'none',
      zIndex: 1000
    }}>
      {Math.round(scale * 100)}% | Ctrl+Scroll: Zoom | Drag: Pan | DblClick: Reset
    </div>
  )

  return (
    <>
      {isImage ? (
        <div
          ref={containerRef}
          style={{
            width: '100%',
            overflow: 'hidden',
            position: 'relative',
            backgroundColor: '#f5f5f5',
            display: 'flex',
            justifyContent: 'center'
          }}
          {...containerEvents}
        >
          <div
            ref={contentRef}
            style={{
              transform: `translate(${position.x}px, ${position.y}px) scale(${scale})`,
              transformOrigin: 'center top',
              cursor: isDragging ? 'grabbing' : 'grab',
              transition: isDragging ? 'none' : 'transform 0.1s ease-out',
              display: 'inline-block',
              userSelect: 'none'
            }}
          >
            <img
              className="imgPdf"
              src={imgSrc}
              draggable="false"
              style={{ display: 'block', pointerEvents: 'none' }}
            />
          </div>
          {zoomInfo}
        </div>
      ) : isPdf ? (
        !pdfSrc ? (
          <div style={{ padding: '20px', textAlign: 'center' }}>Loading PDF...</div>
        ) : (
          <div
            ref={containerRef}
            style={{
              width: '100%',
              overflow: 'hidden',
              position: 'relative',
              backgroundColor: '#525659',
              display: 'flex',
              justifyContent: 'center'
            }}
            {...containerEvents}
          >
            <div
              ref={contentRef}
              style={{
                transform: `translate(${position.x}px, ${position.y}px) scale(${scale})`,
                transformOrigin: 'center top',
                cursor: isDragging ? 'grabbing' : 'grab',
                transition: isDragging ? 'none' : 'transform 0.1s ease-out',
                userSelect: 'none'
              }}
            >
              <Document
                file={pdfSrc}
                onLoadSuccess={onDocumentLoadSuccess}
                loading={
                  <div style={{ padding: '20px', textAlign: 'center', color: 'white' }}>
                    Loading PDF...
                  </div>
                }
              >
                {Array.from(new Array(numPages), (el, index) => (
                  <Page
                    key={`page_${index + 1}`}
                    pageNumber={index + 1}
                    renderTextLayer={false}
                    renderAnnotationLayer={false}
                    loading=""
                    style={{ pointerEvents: 'none' }}
                  />
                ))}
              </Document>
            </div>
            {zoomInfo}
          </div>
        )
      ) : 'File cannot show, please download this file'}
    </>
  )
}